import { Controller } from "@hotwired/stimulus"

// Live 3-line caption window (previous · current · next) synced to the sibling
// player. The full transcript text stays in visually-hidden source spans (one
// per segment, each carrying data-start-second) so screen readers still get the
// whole transcript; only three lines render visually at a time.
//
// Usage: put data-controller="live-captions" on a wrapper that contains BOTH the
// player ([data-media-player-target="media"]) and a rendered _live_captions partial.
export default class extends Controller {
  static targets = ["segment", "prev", "current", "next"]

  connect() {
    this.activeIndex = null
    this.media = this.element.querySelector('[data-media-player-target="media"]') ||
                 this.element.querySelector("video, audio")
    this.starts = this.segmentTargets.map((el) => {
      const start = Number.parseFloat(el.dataset.startSecond)
      return Number.isFinite(start) ? start : 0
    })

    this.boundUpdate = this.update.bind(this)
    if (this.media) {
      this.media.addEventListener("timeupdate", this.boundUpdate)
      this.media.addEventListener("seeked", this.boundUpdate)
      this.media.addEventListener("loadedmetadata", this.boundUpdate)
    }

    this.update()
  }

  disconnect() {
    if (!this.media) return

    this.media.removeEventListener("timeupdate", this.boundUpdate)
    this.media.removeEventListener("seeked", this.boundUpdate)
    this.media.removeEventListener("loadedmetadata", this.boundUpdate)
  }

  update() {
    const time = this.media && Number.isFinite(this.media.currentTime) ? this.media.currentTime : 0

    let active = 0
    for (let i = this.starts.length - 1; i >= 0; i--) {
      if (time >= this.starts[i]) {
        active = i
        break
      }
    }

    if (active === this.activeIndex) return
    this.activeIndex = active

    this.setLine("prev", active - 1)
    this.setLine("current", active)
    this.setLine("next", active + 1)
  }

  setLine(name, index) {
    const target = this[`${name}Target`]
    if (!target) return

    const source = index >= 0 && index < this.segmentTargets.length ? this.segmentTargets[index] : null
    target.textContent = source ? source.textContent.trim() : ""
  }
}
